import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { getVehiclesArrayUntilRefactor } from "src/store/selectors/vehicles";
import { localizationDefaults } from "src/utils";
import MyGarage from "./MyGarage";

function mapStateToProps(state: ApplicationStore) {
    const { account, deal, onlineShopper } = state;
    return {
        deal,
        isViewingSoftCreditRatingForm: onlineShopper.isViewingSoftCreditRatingForm,
        open: onlineShopper.isDrawerOpen,
        region: (account && account.address && account.address.country) || localizationDefaults.country,
        srpLink: onlineShopper.srpLink,
        vehicles: getVehiclesArrayUntilRefactor(state),
    };
}

export default connect(mapStateToProps)(MyGarage);
